import script from "./TableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TableItem.vue?vue&type=script&setup=true&lang=js"

export default script